import { create } from "zustand";

type JobModalState = {
  isOpen: boolean;
  jobId: string | null;
  defaultValues: Partial<{
    title: string;
    description: string;
    department: string;
    category: string;
    salaryRange: string;
    requirements: string;
    responsibilities: string;
    qualifications: string;
    contactInfo: string;
    applicationUrl: string;
    status: "active" | "closed" | "draft";
    postedDate: Date;
    expirationDate: Date;
    featuredImageId: string;
    attachmentId: string;
  }>;
  setIsModalOpen: (isOpen: boolean) => void;
  setJobId: (id: string | null) => void;
  setDefaultValues: (
    values: Partial<{
      title: string;
      description: string;
      department: string;
      category: string;
      salaryRange: string;
      requirements: string;
      responsibilities: string;
      qualifications: string;
      contactInfo: string;
      applicationUrl: string;
      status: "active" | "closed" | "draft";
      postedDate: Date;
      expirationDate: Date;
      featuredImageId: string;
      attachmentId: string;
    }>,
  ) => void;
};

export const useJobsModal = create<JobModalState>((set) => ({
  isOpen: false,
  jobId: null,
  defaultValues: {},
  setIsModalOpen: (isOpen) => set({ isOpen }),
  setJobId: (id) => set({ jobId: id }),
  setDefaultValues: (values) => set({ defaultValues: values }),
}));
